import React, {useState} from 'react';
import {Button} from '../ButtonElements';
import { 
   HeroContainer,
   HeroBg,
   HeroContent,
   HeroH1,
   HeroP,
   HeroBtnWrapper,
   ArrowForward,
   ArrowRight 
   } from './HeroElements'

const HeroSection = () => {
   const [hover, setHover] = useState(false)

   const onHover = () => {
      setHover(!hover)
   }

   return (
      <HeroContainer id='home'>
         <HeroBg>
         </HeroBg>
         <HeroContent>
            <HeroH1>Olá!</HeroH1>
            <HeroH1>Bem-vindo ao BalmaDev</HeroH1>
            <HeroP>
               Criamos Landing Pages que dão vida ao seu negócio.
            </HeroP>
            <HeroBtnWrapper>
            <Button href="https://wa.link/uvvu0r" target="_blank" to='about' onMouseEnter={onHover} onMouseLeave={onHover} primary='true' dark='true' smooth={true} duration={500} spy={true} exact='true' offset={-80}>
            Contate-nos{hover ? <ArrowForward /> : <ArrowRight/>}
            </Button>
            </HeroBtnWrapper>
         </HeroContent>
      </HeroContainer>
   )
}

export default HeroSection
